import React from 'react'
import moment from 'moment'
import 'moment/locale/nl'
import { css } from 'emotion'
import api from '../services/api'
import Chart, { intervals } from './Chart'
import ChartLegendItem from './ChartLegendItem'
import ChartLegend from './ChartLegend'
import ContractDatePreview from './ContractDatePreview'
import wait from '../utils/wait'

class ContractMonthChart extends React.Component {

    state = {
        loading: true,
        data: null,
        chartData: {},
        properties: [
            'dtg',
            'dtgPrevYear'
        ]
    }

    componentDidMount() {
        this.fetch()
    }

    componentDidUpdate(prevProps) {

        if (prevProps.recordId !== this.props.recordId) {

            this.setState({
                loading: true
            })

            this.fetch()
        }
    }

    fetch = async () => {

        await wait(1000)

        const response = await api.request({
            method: 'post',
            data: {
                query: `
                    query contractMonthChart($input: ContractMonthChartInput!) {
                        viewer {
                            contractMonthChart(input: $input)
                        }
                    }
                `,
                variables: {
                    input: {
                        contractId: this.props.source.contractId,
                        date: this.props.source.startDate
                    }
                }
            }
        })

        const data = response.data.data.viewer.contractMonthChart

        const chartData = data.contractDates.reduce((result, contractDate) => {
            result[contractDate.date] = contractDate
            return result
        }, {})

        this.setState({
            loading: false,
            data,
            chartData
        })
    }

    dataPointGetter = ({ date }) => this.state.chartData[date]

    handlePropertyToggle = ({ dataKey }) => {

        let properties = [...this.state.properties]

        if (properties.includes(dataKey)) {
            properties = properties.filter(i => i !== dataKey)
        } else {
            properties.push(dataKey)
        }

        this.setState({
            properties
        })
    }

    tooltipRenderer = ({ source }) => {

        return <ContractDatePreview
            source={source}
        />
    }

    render() {

        // if (this.state.loading) {
        //     return spinner({ width: 24 })
        // }

        const previousPeriod = moment(this.props.source.startDate).subtract(1, 'year').format('MMMM YYYY')

        console.log('this.state.data', this.state.data)
        console.log('this.state.chartData', this.state.chartData)

        const startDate = moment(this.props.source.startDate)
        const endDate = moment(this.props.source.endDate)

        const properties = [
            { title: 'Huidige periode', description: `(${this.props.source.name})`, dataKey: 'dtg', color: '#0095ff', strokeWidth: 1 },
            { title: 'Vorige periode', description: `(${previousPeriod})`, dashed: true, dataKey: 'dtgPrevYear', color: '#63bfff', strokeDasharray: '5, 3', strokeWidth: 1 },
            { title: 'LesautoDeal Gemiddelde', dataKey: 'stdDtgMean', color: '#000', strokeWidth: 1 },
        ]

        const visibleProperties = properties.filter(property =>
            this.state.properties.includes(property.dataKey)
        )

        return (
            <div
                className={css`
                margin-left: -40px;
                margin-right: -40px;
            `}
            >
                <Chart
                    ref={ref => this.chart = ref}
                    loading={this.state.loading}
                    domain={[-40, 100]}
                    interval={intervals.month}
                    startDate={startDate}
                    endDate={endDate}
                    legend={
                        <ChartLegend>
                            {properties.map(property =>
                                <ChartLegendItem
                                    key={property.dataKey}
                                    title={property.title}
                                    active={this.state.properties.includes(property.dataKey)}
                                    dashed={property.dashed}
                                    color={property.color}
                                    description={property.description}
                                    onClick={() => this.handlePropertyToggle({ dataKey: property.dataKey })}
                                />
                            )}
                        </ChartLegend>
                    }
                    lines={visibleProperties}
                    dataPointGetter={this.dataPointGetter}
                    tooltipRenderer={this.tooltipRenderer}
                />
            </div>
        )
    }
}

export default ContractMonthChart